import { useState } from "react";
import { toast } from "sonner";
import { logError } from "../utils/logger";

export const useAppointmentManagement = (dashboardApi, developerDashboardApi) => {
  const [appointments, setAppointments] = useState([]);
  const [editingAppointment, setEditingAppointment] = useState(null);
  const [editForm, setEditForm] = useState({
    date: "",
    time_slot: "",
    unit_number: "",
  });

  const fetchAppointments = async () => {
    try {
      const r = await dashboardApi.getAppointments();
      if (r.ok) setAppointments(await r.json());
    } catch (e) {
      logError("useAppointmentManagement.fetchAppointments", e);
    }
  };

  const handleAppointmentStatus = async (aptId, status) => {
    try {
      const r = await developerDashboardApi.updateAppointmentStatus(
        aptId,
        status,
      );
      if (!r.ok) throw new Error();
      toast.success(
        `Propuesta ${status === "confirmed" ? "aceptada" : "denegada"}`,
      );
      fetchAppointments();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const openEditAppointment = (apt) => {
    setEditingAppointment(apt);
    setEditForm({
      date: apt.date,
      time_slot: apt.time_slot,
      unit_number: apt.unit_number || "",
    });
  };

  const handleEditAppointment = async () => {
    try {
      const r = await developerDashboardApi.editAppointment(
        editingAppointment.id,
        editForm,
      );
      if (!r.ok) {
        const e = await r.json().catch(() => ({}));
        throw new Error(e.detail || "Error al actualizar");
      }
      toast.success("Propuesta actualizada");
      setEditingAppointment(null);
      fetchAppointments();
    } catch (e) {
      toast.error(e.message);
    }
  };

  return {
    appointments,
    editingAppointment,
    setEditingAppointment,
    editForm,
    setEditForm,
    fetchAppointments,
    handleAppointmentStatus,
    openEditAppointment,
    handleEditAppointment,
  };
};
